// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

enum TranscriptItemType {
  PRONUNCIATION = 'pronunciation',
  PUNCTUATION = 'punctuation',
}

export default TranscriptItemType;
